export default __webpack_public_path__ + "static/media/thumb_1.e76d8060.webp";